import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';


export default function RecordingFab(props) {

  return (
    <Tooltip title="Record" placement={props.rows >= props.cols ? "left" : 'top'}>
      <IconButton
        aria-label='record'
        sx={{
          position: 'absolute',
          bottom: 'calc(50% - 20px)',
          right: props.rows >= props.cols ? 16 : 148,
          bottom: props.rows >= props.cols ? 148 : 16,
          color: '#d3d3d3',
        }}
        color='inherit'
        onClick={() => props.setInfo(true)}
      >
        <FiberManualRecordIcon />
      </IconButton>
    </Tooltip>
  );
}
